import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { RequestService } from './requestService';
import { Observable } from 'rxjs';
import { v4 as uuid } from 'uuid';
import {
  ProcessModel,
  ProcessStepModel,
} from '../../jobs-module/edit-job-tpl-process/process.model';

const defaultSteps = [
  { debug: 'Application', type: 0 },
  { debug: 'One-way video interview', type: 4 },
  { debug: 'Interview', type: 3 },
  { debug: 'Offer', type: 2 },
  { debug: 'Hired', type: 1 },
  { debug: 'Rejected', type: 5 },
  { debug: 'Waiting list', type: 6 },
];

@Injectable()
export class ProcessService {
  private _apiEndpoint = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private _requestService: RequestService
  ) {}

  fetchProcessSteps(jobId): Observable<ProcessModel> {
    return this.http.get<ProcessModel>(
      this._apiEndpoint + `processes/jobs/${jobId}/processes/`
    );
  }

  postProcessSteps(jobId: number, process?: ProcessModel) {
    let steps = [];
    // wiping all id's...
    if (!process) {
      process = this.createDefaultSteps(jobId);
    }
    if (!process.id) {
      steps = process.steps.map(step => {
        const questions = step.questions.map(question =>
          Object.assign(
            {},
            question,
            { id: null },
            {
              alternatives: question.alternatives.map(alt =>
                Object.assign({}, alt, { id: null })
              ),
            }
          )
        );

        const required_fields = step.required_fields.map(req =>
          Object.assign({}, req, { id: null })
        );
        const actions = step.actions.map(action =>
          Object.assign({}, action, { id: null })
        );

        return {
          ...step,
          id: null,
          questions: questions,
          required_fields: required_fields,
          actions: actions,
        };
      });
      process.steps = steps;
    }
    if (process.id) {
      return this.http.put<ProcessModel>(
        `${this._apiEndpoint}processes/jobs/${process.job_id}/processes/`,
        process
      );
    } else {
      return this.http.post<ProcessModel>(
        `${this._apiEndpoint}processes/`,
        process
      );
    }
  }

  createDefaultSteps(jobId: number): ProcessModel {
    return {
      steps: defaultSteps.map((step: ProcessStepModel, index) => {
        return {
          uuid: uuid(),
          from_default: true,
          id: index,
          debug: step.debug,
          type: step.type,
          enabled: step.type !== 4,
          position: index,
          dismissible: index > 0,
          required_fields: [],
          actions: [],
          questions: [],
        };
      }),
      job_id: jobId,
    };
  }
}
